// Global Types
import type {
  $FullRegattaGroup,
} from 'common.data';

// Helpers
import _ from 'lodash';
import config from '../config';

export * from './routes';
export * from './text';

export const setupParams = (
  param1?: null | string,
  param2?: null | string,
): {
  param1: string;
  param2?: string;
} => {
  if (param1 && param2 !== null) {
    return {
      param1,
      param2,
    };
  }

  throw new Error('Invalid params');
};

export const wait = (
  duration: number,
): Promise<void> => new Promise((resolve) => {
  setTimeout(
    resolve,
    duration,
  );
});

export const getRegattaGroupName = (
  regattaGroup?: $FullRegattaGroup,
): null | string => _.get(
  regattaGroup,
  'AltName',
) || _.get(
  regattaGroup,
  'Group.Name',
  null,
);

export const getErrorLevel = (
  error: Error,
  matchMessage: string,
): 'error' | 'warning' => (error.message === matchMessage ? 'warning' : 'error');

export const getLocation = (): {
  host: string;
  subDomain: string;
  url: string;
} => {
  const output = {
    host: '',
    subDomain: '',
    url: '',
  };

  if (window && window.location) {
    output.host = window.location.host;
    output.url = window.location.href;

    const isRegionHost: boolean = _.includes(
      output.host,
      config.DOMAIN,
      3,
    );

    if (isRegionHost === true) {
      const regionSubDomain: string = output.host.substr(
        0,
        2,
      );

      output.subDomain = regionSubDomain;
    }
  }

  return output;
};
